(function ($) {
    $(document).ready(function () {
        // Benefits of Light Therapy
        $('.benefits-items-icon .benefits-item .benefits-item-dot').click(function () {
            var benefitsId = $(this).parents('.benefits-item').attr('data-benefits-id');
            $('.benefits-items-content .benefits-item[data-benefits-id="' + benefitsId + '"]').addClass('active');
            $('.benefits-items-content .benefits-item[data-benefits-id="' + benefitsId + '"]').siblings('.benefits-item').removeClass('active');
        });

        // .mitochondria-item .icon
        $('.mitochondria-item .icon').click(function () {
            $(this).parents('.mitochondria-item').toggleClass('active');
            $(this).parents('.mitochondria-item').siblings('.mitochondria-item').removeClass('active');
            // $(this).next('.text').slideToggle();
        });

        if ($('.rich-text__heading').length > 0) {
            var endText = '';
            $('.rich-text__heading').each(function () {
                var $_this = $(this);
                var text = $_this.text();
                if (text.indexOf('-') != -1) {
                    var textArray = text.split('-');
                    var firstSpace, lastSpace;
                    if (textArray.length > 2) {
                        for (var index = 0; index < textArray.length; index++) {
                            if (index == 0) {
                                lastSpace = textArray[0].lastIndexOf(' ');
                                endText = textArray[0].slice(0, lastSpace) + ' <span class="no-wrap">' + textArray[0].slice(lastSpace).trimLeft();
                            } else {
                                if (index == textArray.length - 1) {
                                    firstSpace = textArray[index].indexOf(' ');
                                    endText += '-' + textArray[index].slice(0, firstSpace) + '</span>' + textArray[index].slice(firstSpace);
                                } else {
                                    firstSpace = textArray[index].indexOf(' ');
                                    lastSpace = textArray[index].lastIndexOf(' ');

                                    endText += '-' + textArray[index].slice(0, firstSpace) + '</span>' + textArray[index].slice(firstSpace, lastSpace) + ' <span class="no-wrap">' + textArray[index].slice(lastSpace).trimLeft();
                                }
                            }
                        }
                    } else {
                        var lastSpace = textArray[0].lastIndexOf(' ');
                        endText = textArray[0].slice(0, lastSpace) + '<span class="no-wrap">' + textArray[0].slice(lastSpace).trimLeft();
                        var firstSpace = textArray[1].indexOf(' ');
                        endText += '-' + textArray[1].slice(0, firstSpace) + '</span>' + textArray[1].slice(firstSpace);
                    }
                    $_this.html(endText)
                }
            })
        }

        // Review Widget
        checkReviewWidget(0);
        function checkReviewWidget(c) {
            setTimeout(() => {
                if ($('#reviews-wrapper').length) {
                    $('#reviews-wrapper #vstar-reviews .list-review').each(function () {
                        var reivewStar = $(this).find(".vstar-star");
                        var reivewBody = $(this).find(".list-review-body");
                        reivewStar.prependTo(reivewBody);
                    });
                    $('#reviews-wrapper #vstar-reviews #reviews-body .vstar-star').show();
                    $('#reviews-wrapper #vstar-reviews #reviews-footer .page-control-item').click(function () {
                        setTimeout(() => {
                            $('#reviews-wrapper #vstar-reviews .list-review').each(function () {
                                var reivewStar = $(this).find(".vstar-star");
                                var reivewBody = $(this).find(".list-review-body");
                                reivewStar.prependTo(reivewBody);
                            });
                            $('#reviews-wrapper #vstar-reviews #reviews-body .vstar-star').show();
                        }, 1000);
                    })
                } else {
                    checkReviewWidget(c + 1)
                };
            }, 2000);
        }

        const appHeight = () => {
            if ($('.section-slide-sticky-image .slider-sticky-mobile .image img').length > 0) {
                var heightStickyImage = $('.section-slide-sticky-image .slider-sticky-mobile .image img').outerHeight();
                $('.sticky-wrapper').css('--height-sticky-image', heightStickyImage + 'px');
            }

            if ($('.blog-slider .card .card__inner .card__media').length > 0) {
                var heightBlogImage = $('.blog-slider .card .card__inner .card__media').outerHeight();
                $('.blog-slider').css('--height-sticky-image', heightBlogImage + 'px');
            }

            if ($('.section-webinar-video .video-list .image-box img').length > 0) {
                var heightVideoImage = $('.section-webinar-video .video-list .image-box img').outerHeight();
                $('.section-content.video-list').css('--height-sticky-image', heightVideoImage + 'px');
            }
          
            if ($('.section-left-slider__images-list--content-image').length > 0) {
                var heightStickyImage = $('.section-left-slider__images-list--content-image').outerHeight();
                $('.slider__images--list').css('--height-sticky-image', heightStickyImage + 'px');
            }
        }
        window.addEventListener('resize', appHeight);
        appHeight();
    });
})(jQuery);